const Tdata=[
    {
    "id": 1,
    "img":"https://html.dynamiclayers.net/dl/news24/img/tab-1.jpg",
    "title": "The Best Fashion Instagrams of the Week",
    "price": 2500,
    "description": "William Braynt went to visit the US.",
    "category": "1",
    "image": "https://newspaper.jollyany.co/images/toa-heftiba-ZoAhudO-BQM-unsplash.jpg#joomlaImage://local-images/toa-heftiba-ZoAhudO-BQM-unsplash.jpg?width=1920&height=1280",
    },
    {
    "id": 2,
    "title": "Beach Lover’s Paradise in the Northwest",
    "description": "Style icon angelina goes to take oscar.",
    "category": "2",
    "image": "https://newspaper.jollyany.co/images/helena-lopes-AJe5BEybfXE-unsplash.jpg#joomlaImage://local-images/helena-lopes-AJe5BEybfXE-unsplash.jpg?width=1920&height=1280",
    },
    {
    "id": 3,
    "title": "The October 2021 Beauty Launches You Need to Know",
    "description": "How to become a wildlife photographer?",
    "category": "3",
    "image": "https://newspaper.jollyany.co/images/alireza-esmaeeli-5SxvhpDg7Kc-unsplash.jpg#joomlaImage://local-images/alireza-esmaeeli-5SxvhpDg7Kc-unsplash.jpg?width=1920&height=1280",
    },
    {
        "id": 4,
        "title": "The future of possible innovation for business company.",
        "description": "linin park singer is no more. he is top in the world.",
        "category": "1",
        "image": "https://newspaper.jollyany.co//images/valeria-andersson-0IGhARplNzY-unsplash.jpg#joomlaImage://local-images/valeria-andersson-0IGhARplNzY-unsplash.jpg?width=1920&height=1280",
        },
]
export default Tdata;